module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bg-main g-pos-rel"
  }, [_c('div', {
    staticClass: "container g-pos-rel g-z-index-1 g-py-70"
  }, [_c('div', {
    staticClass: "row align-items-lg-center g-mt-20"
  }, [_c('div', {
    staticClass: "col-lg-6 order-lg-2 g-mb-20"
  }, [_c('div', {
    staticClass: "g-pos-rel g-pl-15--lg"
  }, [_c('img', {
    staticClass: "img-fluid w-100 u-shadow-v19 g-brd-around g-brd-7 g-brd-secondary rounded",
    attrs: {
      "src": _vm.home_banner_img,
      "alt": "Image Description"
    }
  }), _vm._v(" "), (_vm.accountType == 'master') ? _c('div', {
    staticClass: "text-center g-mt-10"
  }, _vm._l((_vm.minorSponsorLogos), function(logo, index) {
    return _c('label', {
      key: index,
      staticClass: "minor-sponsor-h home"
    }, [_c('a', [_c('img', {
      staticClass: "min_sp_img",
      attrs: {
        "src": logo
      }
    })])])
  }), 0) : _c('div', {
    staticClass: "text-center g-mt-10"
  }, _vm._l((_vm.sponsors.minorLogos), function(logo, index) {
    return (logo != '') ? _c('label', {
      key: index,
      staticClass: "minor-sponsor-h home"
    }, [(_vm.sponsors.hyperLinkMinor[index] != '') ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.sponsors.hyperLinkMinor[index]
      }
    }, [_c('img', {
      staticClass: "min_sp_img",
      attrs: {
        "src": logo
      }
    })]) : _c('a', [_c('img', {
      staticClass: "min_sp_img",
      attrs: {
        "src": logo
      }
    })])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 order-lg-1"
  }, [(_vm.accountType != 'master') ? _c('div', {
    staticClass: "mb-5"
  }, [(_vm.sponsors.majorLogoLg == '') ? _c('span', {
    staticClass: "cltl-span"
  }, [_c('a', [_c('img', {
    staticClass: "cltl-logo-white g-mb-20",
    attrs: {
      "src": _vm.cltl_logo_white
    }
  })])]) : (_vm.sponsors.hyperLinkMajor == '') ? _c('span', {
    staticClass: "cltl-span"
  }, [_c('a', [_c('img', {
    staticClass: "cltl-logo-white g-mb-20",
    attrs: {
      "src": _vm.sponsors.majorLogoLg
    }
  })])]) : _c('span', {
    staticClass: "cltl-span"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.sponsors.hyperLinkMajor
    }
  }, [_c('img', {
    staticClass: "cltl-logo-white g-mb-20",
    attrs: {
      "src": _vm.sponsors.majorLogoLg
    }
  })])]), _vm._v(" "), (this.sponsors.header != '') ? _c('h1', {
    staticClass: "g-font-size-25--md g-color-white mb-4 text-center"
  }, [_vm._v(_vm._s(this.sponsors.header))]) : _c('h1', {
    staticClass: "g-font-size-25--md g-color-white mb-4 text-center"
  }, [_vm._v("Changing Life through Lenses®")]), _vm._v(" "), (this.sponsors.paragraph != '') ? _c('p', {
    staticClass: "g-color-white-opacity-0_7 g-font-size-20--md g-font-size-17 text-center"
  }, [_vm._v(_vm._s(this.sponsors.paragraph))]) : _c('p', {
    staticClass: "g-color-white-opacity-0_7 g-font-size-20--md g-font-size-17 text-center"
  }, [_vm._v("Welcome!  Thank you for being a champion of sight in your community.  We are excited to partner with you and provide you the resources you need to support your charitable work!")])]) : _c('div', {
    staticClass: "mb-5"
  }, [_c('span', {
    staticClass: "cltl-span"
  }, [_c('a', [_c('img', {
    staticClass: "cltl-logo-white g-mb-20",
    attrs: {
      "src": _vm.cltl_logo_white
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "g-font-size-25--md g-color-white mb-4 text-center"
  }, [_vm._v("Changing Life through Lenses®")]), _vm._v(" "), _c('p', {
    staticClass: "g-color-white-opacity-0_7 g-font-size-20--md g-font-size-17"
  }, [_vm._v("Welcome!  Thank you for being a champion of sight in your community.  We are excited to partner with you and provide you the resources you need to support your charitable work!")])])])])]), _vm._v(" "), _c('svg', {
    staticClass: "g-pos-abs g-bottom-0 g-left-0",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/bag1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 1920 323",
      "enable-background": "new 0 0 1920 323",
      "xml:space": "preserve"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#2c3856",
      "points": "0,323 1920,323 1920,0 "
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#293451",
      "points": "-0.5,322.5 -0.5,131.5 658.3,212.3 "
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7f3621af", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f3621af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/homeData/HomeBanner.vue
// module id = 530
// module chunks = 3